/*
  SOLEIL wipe-in — merchant-applied motion palette reveal.

  GRACEFUL DEGRADATION (Motion Stack §3): this file ships in every project, but
  the motion stack is opt-in. So it has two paths:

    - Stack present (window.SoleilMotion set): GSAP owns the reveal via
      ScrollTrigger. The CSS hands timing to GSAP under `.soleil-motion-ready`
      (transition: none).
    - Stack absent: the original IntersectionObserver + `.is-visible` + CSS
      transition path runs, exactly as before. Nothing requires the stack.

  Load order: the controller's module tag must come BEFORE this defer script in
  snippets/scripts.liquid so window.SoleilMotion is set when this runs (classic
  defer + module scripts execute in document order). Reduced motion is handled
  by Motion.register() (no-op) + the CSS @media block — content shows instantly.

  Stays a classic `defer` script (NOT a module) precisely so it keeps loading on
  non-opted-in projects without an importmap.
*/
(function () {
  'use strict';

  var CLASSES = ['soleil-wipe', 'soleil-fade-up', 'soleil-blur-in', 'soleil-scale-soft', 'soleil-slide-in', 'soleil-typewriter'];
  var SELECTOR = CLASSES.map(function (c) { return '.' + c; }).join(', ');

  // GSAP path config: CSS paints the `from`; GSAP animates to the natural state
  // and leaves the result inline (no clearProps) so the reveal persists.
  var PALETTE = {
    'soleil-wipe': { child: true, from: { yPercent: 110 }, to: { yPercent: 0, duration: 0.7, ease: 'expo.out' } },
    'soleil-fade-up': { from: { autoAlpha: 0, y: 12 }, to: { autoAlpha: 1, y: 0, duration: 0.6, ease: 'power2.out' } },
    'soleil-blur-in': { from: { autoAlpha: 0, filter: 'blur(8px)' }, to: { autoAlpha: 1, filter: 'blur(0px)', duration: 0.7, ease: 'power2.out' } },
    'soleil-scale-soft': { from: { autoAlpha: 0, scale: 0.96 }, to: { autoAlpha: 1, scale: 1, duration: 0.6, ease: 'power2.out' } },
    'soleil-slide-in': { from: { autoAlpha: 0, x: -20 }, to: { autoAlpha: 1, x: 0, duration: 0.6, ease: 'power2.out' } },
    'soleil-typewriter': { from: { clipPath: 'inset(0 100% 0 0)' }, to: { clipPath: 'inset(0 0% 0 0)', duration: 1.2, ease: 'steps(40)' } }
  };

  function gsapPath(Motion) {
    Motion.register(function (ctx) {
      var triggers = [];
      document.querySelectorAll(SELECTOR).forEach(function (el) {
        var key = CLASSES.filter(function (c) { return el.classList.contains(c); })[0];
        if (!key) return;
        var cfg = PALETTE[key];
        var target = cfg.child ? el.children : el;
        var tween = ctx.gsap.fromTo(target, cfg.from, Object.assign({}, cfg.to, {
          scrollTrigger: { trigger: el, start: 'top 85%', once: true },
          onComplete: function () { el.classList.add('is-visible'); }
        }));
        if (tween.scrollTrigger) triggers.push(tween.scrollTrigger);
      });
      return function () { triggers.forEach(function (t) { t.kill(); }); };
    });
  }

  // Original IntersectionObserver fallback (no motion stack).
  function fallbackPath() {
    var els = document.querySelectorAll(SELECTOR);
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function init() {
    if (window.SoleilMotion) gsapPath(window.SoleilMotion);
    else fallbackPath();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
